module.exports = __webpack_public_path__ + "img/pov-agricoltori.2ee1fc29.png";